import React from 'react'
import { useNavigate } from 'react-router-dom'

const SerTab = (props) => {
    const navigator = useNavigate();
  
    return (
      <div className="row-span-6 relative bg-black text-white rounded m-1 p-1 group"  style={{
        backgroundImage: `url(${props.backgroundImage})`,
        backgroundSize:'cover',
      }}>
        
        <div
          className="absolute z-10 inset-0 lg:bg-black opacity-30 rounded pointer-events-none transition-opacity duration-300 group-hover:opacity-0"
        ></div>

  
        <h2 className="m-24 z-10 text-2xl">{props.name}</h2>
        <button
          onClick={() => navigator(props.link)}
          className="bg-white m-5 text-black z-10 rounded-full px-4 py-2 w-24 lg:w-32 mx-auto "
        >
          Explore
        </button>
      </div>

    );
  };
  

export default SerTab